import { Theme } from '@mui/material/styles'
import { SxProps } from '@mui/system'


interface StyleProps {
  container: SxProps<Theme>
  form: SxProps<Theme>
}

const assignPasswordStyles = (theme: Theme): StyleProps => ({
        container: {
        minHeight: '88vh',
        justifyContent: 'center',
        alignContent: 'space-between',
        [theme.breakpoints.down('sm')]: {
            minHeight: 'auto',
            width: '100% !important',
        },
        '&.seminar': {
            minHeight: 'auto',
        },
    },
    form: {
            maxWidth: '442px',
            width: '100%',
            marginTop: '15vh',
            marginBottom: '64px',
            paddingLeft: '24px',
            paddingRight: '24px',
            '&live':{
                marginTop: '0',
            },
            '&.seminar':{
                marginBottom: '0',
                marginTop: '0',
            },
            '& .Mui-error': {
                borderColor: theme.palette.warning.main,
                backgroundColor: theme.palette.warning.light,
                color: theme.palette.warning.main,
            },
            "& p.Mui-error": {
                backgroundColor: theme.palette.common.white,
            },
            [theme.breakpoints.down('sm')]: {
                width: '90%',
                margin: '100px auto 20px',
                padding: 0,
                '& p, span': {
                    fontSize: theme.typography.body2.fontSize,
                },
                '& .MuiInputBase-root': {
                    fontSize: theme.typography.body2.fontSize,
                    maxHeight: 40,
                }
            },
        },
})

export default assignPasswordStyles;